import request from '#/utils/request';
import { keysToCamel } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse, parseVer4ListResponse } from '#/api/adapters/envelope';

/**
 * GET /system/role/{id}/permissions
 * 相容 list envelope 或 data.permissions／data 陣列。
 * @see docs/API_SYSTEM_ACCESS.md
 */
export async function fetchRolePermissions(roleId) {
  const { data: raw } = await request.get(`/system/role/${roleId}/permissions`);

  if (Array.isArray(raw?.list)) {
    return parseVer4ListResponse(raw);
  }

  const parsed = parseVer4DetailResponse(raw);
  const data = parsed.data;
  let list = [];
  if (Array.isArray(data)) {
    list = data;
  } else if (Array.isArray(data?.permissions)) {
    list = data.permissions;
  } else if (Array.isArray(data?.list)) {
    list = data.list;
  }

  return {
    message: parsed.message,
    route: parsed.route,
    data: keysToCamel(list),
  };
}
